var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResearchPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11V24Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28H19V30H13V28Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8101 18.1422C9.42609 16.8642 7.99609 15.5232 7.99609 12.0012C7.99609 7.59022 11.5841 4.00122 15.9961 4.00122V2.00122C10.4811 2.00122 5.99609 6.48722 5.99609 12.0012C5.99609 16.4022 7.99509 18.2692 9.45509 19.6182C10.4671 20.5522 10.9961 21.0832 10.9961 22.0012H12.9961C12.9961 20.1622 11.8851 19.1352 10.8101 18.1422Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9.59L17.41 6L16 7.41L21 12.41L30 3.41L28.59 2L21 9.59Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8 14C23.364 16.089 22.256 17.143 21.178 18.143C20.107 19.135 19 20.161 19 22H21C21 21.081 21.527 20.55 22.536 19.614C23.747 18.492 25.339 17.004 25.839 14H23.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchPoint);
export default __webpack_public_path__ + "static/media/research-point.a375800476f450507c5b9412a38236e1.svg";
export { ForwardRef as ReactComponent };